import { useQueryClient } from 'react-query';
import { ApiMethod } from 'services/api';
import { FETCH_LISTS_URL, DELETE_LIST_ENDPOINT } from 'api/ManageListsAPI';

import { useRestMutation } from 'utils/hooks/api/useRestMutation';
import { useToastNotificationCallback } from 'utils/hooks/useToastNotificationCallback';
import { useTranslation } from 'modules/domains/list';
import { createEmailListIdParams } from '../utils';
import { List } from '../types';

export const useDeleteListMutation = (list: List) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { positive, negative } = useToastNotificationCallback();

  const { mutate, isSuccess, isError, isLoading } = useRestMutation(
    createEmailListIdParams(list, DELETE_LIST_ENDPOINT),
    ApiMethod.post,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(FETCH_LISTS_URL);
        positive(t('indexPage.toasts.deleteSuccess', { listName: list?.name }));
      },
      onError: () => {
        negative(t('indexPage.toasts.deleteError'));
      },
    },
  );

  const deleteList = () => {
    if (list) mutate({});
  };

  return { deleteList, isSuccess, isError, isLoading };
};
